import React, { useContext } from 'react';
import { StateContext } from "../state";
import Button from './library/Buttons';
import classnames from 'classnames';
import { logger } from "../utils/logging";
// Utils
import { substituteVariablesInString } from '../utils/substitutions';
import { applyTransformations } from "../utils/configTransformations";
import { LOG_LEVELS } from "../utils/enums";
import { get } from 'lodash/object';

const getDangerouslySetInnerHTML = htmlString => {
  return {
    __html: htmlString,
  }
};

const getComponentType = (componentType = 'span') => {
  const CUSTOM_COMPONENT_TYPES = {
    'Button': Button,
  };

  if(CUSTOM_COMPONENT_TYPES[componentType]) return CUSTOM_COMPONENT_TYPES[componentType];
  return componentType;
};

const decorateTransformations = (transformations = [], dataForVariableSubstitutions) => {
  return transformations.map(transformation => {
    const data = transformation.data;
    if(data) {
      // perform any substitutions on the data variables so that we can use variables in the config
      for (let field in data) { // eslint-disable-line no-unused-vars
        data[field] = substituteVariablesInString(data[field], dataForVariableSubstitutions)
      }
      return ({
        ...transformation,
        data: {
          ...dataForVariableSubstitutions,
          ...data,
        }
      });
    }
    else {
      return ({
        ...transformation,
        data: dataForVariableSubstitutions,
      })
    }
  });
};

const ConfigComponent = ({config, data, className, type, debug, actions, ...other}) => {
  if(debug){
    debugger;
  }
  let [applicationState] = useContext(StateContext);
  const {payment, paymentNetworkConfig, configuration} = applicationState;
  const dataForVariableSubstitutions = {payment, paymentNetwork: paymentNetworkConfig, ...data};

  try {
    // if config is simply a string, render a <span>
    if(typeof config === 'string') {
      return (
        React.createElement(
          type || 'span',
          {
            dangerouslySetInnerHTML: getDangerouslySetInnerHTML(substituteVariablesInString(config, dataForVariableSubstitutions)),
            className,
            ...other,
          }
        )
      )
    }
    else if(Array.isArray(config)){
      const output = config.map((item, idx) => {
        // accept mixed array of strings/object configs
        if(typeof item === 'string') {
          return(
            React.createElement(
              getComponentType(type),
              {
                key: item.string ? `${item.string.substring(0, 5)}-${idx}` : idx,
                children: substituteVariablesInString(item, dataForVariableSubstitutions),
                ...other,
              }
            )
          );
        }
        else {
          const variableAfterSubstitutions = substituteVariablesInString(item.string, dataForVariableSubstitutions);
          const transformations = decorateTransformations(item.transformations, dataForVariableSubstitutions);
          const variableAfterTransformations = applyTransformations(variableAfterSubstitutions, transformations);

          let props = {};
          if(className) {
            props.className = className;
          }

          if(item.props){
            props = {
              ...props,
              ...item.props,
              className: classnames(props.className, item.props.className),
            }
          }
          if(item.children){
            item.children = <ConfigComponent config={item.children} data={data} {...other} />
          }
          if(variableAfterTransformations){
            props = {
              ...props,
              dangerouslySetInnerHTML: getDangerouslySetInnerHTML(variableAfterTransformations),
            }
          }
          if(item.action && get(actions, item.action)) {
            props.onClick = get(actions, item.action)
          }

          return(
            React.createElement(
              getComponentType(item.type || type),
              {
                key: item.string ? `${item.string.substring(0, 5)}-${idx}` : idx,
                ...props,
                ...other,
              }
            )
          );
        }
      });

      return <>{output}</>;
    }
    else {
      const message = 'no config item found';
      console.error(message);

      const logData = {
        message,
      };

      const programId = get(payment, 'programId');
      const programName = get(configuration, 'programName');

      if(programId) logData.programId = programId;
      if(programName) logData.programId = programName;

      logger(logData, LOG_LEVELS.ERROR);
      return null;
    }
  } catch (error) {
    const message = 'uncaught error in <ConfigComponent/>';
    console.error(error, message);

    const logData = {
      message,
      error,
    };

    const programId = get(payment, 'programId');
    const programName = get(configuration, 'programName');

    if(programId) logData.programId = programId;
    if(programName) logData.programId = programName;

    logger(logData, LOG_LEVELS.ERROR);

    return null;
  }
};

export default ConfigComponent;
